import React, { Component } from "react";
import FocusLock from "react-focus-lock";

import {SplashScreen} from "./components/SplashScreen";
import {ProgramOverview} from "./components/ProgramOverview";
import {Dialogs} from "./components/Dialogs/Dialogs";

import "./style.scss";

// const sections = ["SPLASH_SCREEN", "PROGRAM_OVERVIEW"];
// const dialogs = [
//   "CHOOSE_TYPE",
//   "CONFIRM_RUN",
//   "CONFIRM_DELETE",
//   "CYCLES_COMPLETE"
// ];

export class ThermocyclerControls extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getSectionClass = (section) => {
    let sections = {
      "SPLASH_SCREEN": "thermocycler-splash-screen",
      "PROGRAM_OVERVIEW": "thermocycler-overview",
      "PROGRAM_RUNNER": "thermocycler-runner"

    }
    return (sections.hasOwnProperty(section))?sections[section]:null
  }

  getSection = (currentSection) => {
    let section = null;

    switch (currentSection) {
      case "SPLASH_SCREEN":
        section = <SplashScreen
                    id={this.props.id}
                    setSection={this.props.setThermocyclerSection}
                    setInnerSection={this.props.setThermocyclerInnerSection}
                    eraseSequence={this.props.eraseThermocyclerSequence}
                    sequence={this.props.sequence}
                    running={this.props.running}
                    setCurrentTime={this.props.setThermocyclerCurrentTime}
                    setTotalTime={this.props.setThermocyclerTotalTime}
                    setTotalElapsedTime={this.props.setThermocyclerTotalElapsedTime}
                    setDurations={this.props.setThermocyclerDurations}
                  />;
        break;
      case "PROGRAM_OVERVIEW":
        section = <ProgramOverview
                    id={this.props.id}

                    // Actions
                    setModal={this.props.setModal}
                    setInnerSection={this.props.setThermocyclerInnerSection}
                    setEditConnection={this.props.setThermocyclerEditConnection}
                    setSection={this.props.setThermocyclerSection}
                    setDialog={this.props.setThermocyclerDialog}
                    setDialogDisplay={this.props.setThermocyclerDialogDisplay}
                    addSequence={this.props.addThermocyclerSequence}
                    removeSequence={this.props.removeThermocyclerSequence}
                    updateSequence={this.props.updateThermocyclerSequence}

                    updateSequenceTemp={this.props.updateThermocyclerSequenceTemp}
                    updateSequenceTime={this.props.updateThermocyclerSequenceTime}
                    updateSequenceRepeat={this.props.updateThermocyclerSequenceRepeat}

                    setSaved={this.props.setThermocyclerSaved}
                    setCurrentTime={this.props.setThermocyclerCurrentTime}
                    setTotalTime={this.props.setThermocyclerTotalTime}
                    setTotalElapsedTime={this.props.setThermocyclerTotalElapsedTime}
                    setRunning={this.props.setThermocyclerRunning}
                    setDurations={this.props.setThermocyclerDurations}

                    setLid={this.props.setThermocyclerLid}
                    setVolume={this.props.setThermocyclerVolume}

                    // State
                    sequence={this.props.sequence}
                    editConnection={this.props.editConnection}
                    innerSection={this.props.innerSection}
                    displayDialog={this.props.displayDialog}
                    saved={this.props.saved}

                    //State
                    open={this.props.open}
                    durations={this.props.durations}
                    volume={this.props.volume}
                    lid={this.props.lid}
                    currentTime={this.props.currentTime}
                    running={this.props.running}
                    totalTime={this.props.totalTime}
                    totalElapsedTime={this.props.totalElapsedTime}
                  />;
        break;
      default:
      // code block
    }

    return section;
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.saved !== this.props.saved && this.props.saved) {
      this.props.setThermocyclerInnerSection({
        id: this.props.id,
        innerSection: "THERMOCYCLER_TABLE"
      });
    }
  }

  render() {
    return (
      <FocusLock>
        <div className={"modal-section thermocycler-controls"}>
          <div className="modal-header">
            <h2>Program The Thermocycler</h2>
          </div>
          <div className="modal-body">
            <div className={"modal-inner "+this.getSectionClass(this.props.currentSection)}>
              {this.getSection(this.props.currentSection)}
            </div>
            <Dialogs
              id={this.props.id}
              setSection={this.props.setThermocyclerSection}
              currentDialog={this.props.currentDialog}
              displayDialog={this.props.displayDialog}
              setDialogDisplay={this.props.setThermocyclerDialogDisplay}
              sequence={this.props.sequence}
              addSequence={this.props.addThermocyclerSequence}
              removeSequence={this.props.removeThermocyclerSequence}
              updateSequence={this.props.updateThermocyclerSequence}
              setInnerSection={this.props.setThermocyclerInnerSection}
              setEditConnection={this.props.setThermocyclerEditConnection}
              levelSelected={this.props.levelSelected}
            />
          </div>
        </div>
      </FocusLock>
    );
  }
}
